// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"180":"2cca2479","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"180":"4f6552fa91856f34f4b0","245":"4b884ded0382f70435dc","452":"a11d3fdcf150092c5345","453":"e6f52b367b71c93610ed","522":"7e9b50b87ca2aaa4506a","551":"d6d678d5adcc59196452"}[chunkId] + ".js";
};